import { render, staticRenderFns } from "./BookletPrint.vue?vue&type=template&id=121cc812&scoped=true&"
import script from "./BookletPrint.vue?vue&type=script&lang=js&"
export * from "./BookletPrint.vue?vue&type=script&lang=js&"
import style0 from "./BookletPrint.vue?vue&type=style&index=0&id=121cc812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121cc812",
  null
  
)

export default component.exports